<p-dialog header="揀貨狀態變更" [(visible)]="isVisible" appendTo="body" (visibleChange)="dialogVisibleChange($event)"
  [modal]="true" [draggable]="false" [resizable]="false" [style]="{ width: '80%' }">
  <h2>Booking單號：{{ booking?.bookingNo }}</h2>
  <div>
    <p-table #detailPcikDataTable laasDataTableSetting [tableKey]="preferenceKey" [columns]="pickUpcolumns" [defaultColumns]="pickUpcolumns" [value]="tmpDetails" [(selection)]="selectedRows" [selectable]="true" class="datatable" [loading]="isLoading">
      <ng-template pTemplate="caption">


        <p-toolbar>
          <div class="p-toolbar-group-left">
            <laas-table-column-toggle
            [optionsColumn]="pickUpcolumns"
            [dataTable]="detailPcikDataTable">
            </laas-table-column-toggle>
          </div>
          <div class="p-toolbar-group-right">
            <button pButton pRipple icon="fas fa-box" pTooltip="{{selectedPickingText}}"
              (click)="selectedPicking($event)"></button>
          </div>
        </p-toolbar>
      </ng-template>
      <ng-template pTemplate="colgroup" let-selectedPicUpCols>
        <colgroup>
          <col style="width: 3vw;">
          <col *ngFor="let col of selectedPicUpCols" [style]="{ width: col.width + 'px' }">
        </colgroup>
      </ng-template>
      <ng-template pTemplate="header" let-selectedPicUpCols>
        <tr>
          <th>
            <p-tableHeaderCheckbox></p-tableHeaderCheckbox>
          </th>
          <th [pSortableColumn]="col.field" *ngFor="let col of selectedPicUpCols" pResizableColumn
            pReorderableColumn [attr.field]="col.field">
            {{col.header}}
            <p-sortIcon [field]="col.field"></p-sortIcon>
          </th>
        </tr>
      </ng-template>
      <ng-template pTemplate="body" let-rowData let-columns="columns" let-rowIndex="rowIndex">
        <tr>
          <td>
            <p-tableCheckbox [value]="rowData"></p-tableCheckbox>
          </td>
          <td *ngFor="let col of columns">
            <div [ngSwitch]="col.field">
              <ng-container *ngSwitchCase="'doStatus'">
                <div class="overflow-text">
                  {{ rowData[col.field] | optionsMapping: DOStatusOptions }}
                </div>
              </ng-container>
              <ng-container *ngSwitchCase="'noPickingDo'">
                <div class="overflow-text">
                  {{ rowData[col.field] | optionsMapping: noPickingDoOptions }}
                </div>
              </ng-container>
              <ng-container *ngSwitchDefault>
                <ng-container [ngSwitch]="col.dataType">
                  <ng-container *ngSwitchCase="'date'">
                    <div class="overflow-text">
                      {{ rowData[col.field] | date:'yyyy-MM-dd HH:mm:ss':this.laasSetting.facilityTimeZone | replaceNullWith:'-' }}
                    </div>
                  </ng-container>
                  <ng-container *ngSwitchCase="'array'">
                    <ng-container *ngIf="rowData[col.field].length > 0; else displayEmpty">
                      <ng-container *ngFor="let item of rowData[col.field]; index as i">
                        <div class="overflow-text">
                          {{ i + 1 }}. {{ item + '\t\n'}}
                        </div>
                      </ng-container>
                    </ng-container>
                  </ng-container>
                  <ng-container *ngSwitchDefault>
                    <div class="overflow-text">
                      {{ rowData[col.field] | replaceNullWith:'-'}}
                    </div>
                  </ng-container>
                </ng-container>
              </ng-container>
              <ng-template #displayEmpty>
                -
              </ng-template>
            </div>
          </td>
        </tr>
      </ng-template>
      <ng-template pTemplate="emptymessage" let-columns>
        <tr>
          <td [attr.colspan]="columns.length" style="text-align: center;">
            {{ 'Common.Table.NoData' | translate }}
          </td>
        </tr>
      </ng-template>
    </p-table>
  </div>
  <div class="mt-2 text-center">
    <button pRipple pButton label="{{ 'Common.Button.Confirm' | translate }}"
      (click)="confirmBtnClick($event)"></button>
    <button pRipple pButton label="{{ 'Common.Button.Cancel' | translate }}" class="p-button-secondary ml-2"
      (click)="cancelBtnClick($event)"></button>
  </div>
</p-dialog>
